import type { SeoLinkPlace } from '../interfaces';

type ExtraLinkTreeProps = {
    heading: string;
    linkPrefix: string;
    data: SeoLinkPlace[];
    url: string;
};

export const ExtraLinkTree = ({ heading, linkPrefix, data, url }: ExtraLinkTreeProps) => {
    const linkTree = (destinations) => (
        <div className="text-center" key={`eltDestinations${url}`}>
            {destinations.map((destination) => (
                <a
                    key={`eltDestination${url}${destination.country}${destination.city}`}
                    href={`${url}${destination.country.replace(/ /g, '+').toLowerCase()}/${destination.city
                        .replace(/ /g, '+')
                        .toLowerCase()}/`}
                    className="block py-16">
                    {linkPrefix} {destination.city}
                </a>
            ))}
        </div>
    );

    const renderTree = () => {
        const chunkSize = 8;
        const numberOfChunks = Math.ceil(data.length / chunkSize);

        const chunkedDestinations = Array.from({ length: numberOfChunks }, (_, index) =>
            data.slice(index * chunkSize, index * chunkSize + chunkSize),
        );

        return chunkedDestinations.map(linkTree);
    };

    return (
        <section className="m-16 p-16 mb-64 rounded-8" aria-labelledby="seo-extralinktree-title">
            <h2 id="seo-extralinktree-title" className="p-8 text-center">
                {heading}
            </h2>
            <div className="grid grid-cols-2 lg:grid-cols4 p-8">{renderTree()}</div>
        </section>
    );
};
